import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class OrbsAnimation {
	constructor() {
		document.addEventListener('bless', (e) => {
			if (!e.target) {
				return;
			}

			this.init(e.target);
		});
	}

	init(element) {
		const container = element.querySelector('[data-what-we-do]');

		if (!container) {
			return;
		}

		const orbs = container.querySelectorAll('[data-orb]');

		if (!orbs.length) {
			return;
		}

		const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

		if (mediaQuery.matches) {
			return;
		}

		const mainTimeline = gsap.timeline({
			scrollTrigger: container.querySelector('.m-what-we-do__items'),
			delay: 0.1,
		});

		orbs.forEach((orb, index) => {
			const content = orb.querySelector('.c-orb__content');

			let tl = gsap
				.timeline()
				.fromTo(
					orb,
					{
						y: 80,
					},
					{
						y: 0,
						duration: 2,
						ease: 'back.out(1.7)',
					}
				)
				.fromTo(
					content,
					{
						y: 30,
					},
					{
						y: 0,
						duration: 2.4,
						ease: 'back.out(1.5)',
					},
					'-=2'
				);

			mainTimeline.add(tl, index * 0.1);
		});
	}
}
